module.exports = __webpack_public_path__ + "img/icon_cursor-right.d9000f24.svg";